import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['HarmonicBackgroundLevel'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postHarmonicBackgroundLevelGetHarmonicBackgroundLevelValues: build.query<
        PostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesApiResponse,
        PostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/HarmonicBackgroundLevel/get-harmonic-background-level-values`,
          method: 'POST',
          body: queryArg.body,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            measurementDeviceTechnicalName: queryArg.measurementDeviceTechnicalName,
            tsoId: queryArg.tsoId,
          },
        }),
        providesTags: ['HarmonicBackgroundLevel'],
      }),
      postHarmonicBackgroundLevelExportHarmonicBackgroundLevelValues: build.mutation<
        PostHarmonicBackgroundLevelExportHarmonicBackgroundLevelValuesApiResponse,
        PostHarmonicBackgroundLevelExportHarmonicBackgroundLevelValuesApiArg
      >({
        query: (queryArg) => ({
          url: `/HarmonicBackgroundLevel/export-harmonic-background-level-values`,
          method: 'POST',
          body: queryArg.body,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            measurementDeviceTechnicalName: queryArg.measurementDeviceTechnicalName,
            tsoId: queryArg.tsoId,
          },
        }),
        invalidatesTags: ['HarmonicBackgroundLevel'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as harmonicBackgroundLevelApi };
export type PostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesApiResponse =
  /** status 200 OK */ ApiCommonResponsesHarmonicBackgroundLevelParameterValuesResponse[];
export type PostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesApiArg = {
  /** Starting time for which the harmonic background levels will be retrieved */
  from?: string;
  /** Ending time for which the harmonic background levels will be retrieved */
  to?: string;
  /** MeasurementDevice for which the harmonic background levels will be
    retrieved */
  measurementDeviceTechnicalName?: string;
  /** The MeasurementDevice of this tso is used for retrieval of the harmonic background levels */
  tsoId?: number;
  /** The MeasurementParameters for which the harmonic background levels will be
    retrieved */
  body: number[];
};
export type PostHarmonicBackgroundLevelExportHarmonicBackgroundLevelValuesApiResponse = unknown;
export type PostHarmonicBackgroundLevelExportHarmonicBackgroundLevelValuesApiArg = {
  /** Starting time for which the harmonic background levels will be exported */
  from?: string;
  /** Ending time for which the harmonic background levels will be exported */
  to?: string;
  /** MeasurementDevice for which the harmonic background levels will be
    exported */
  measurementDeviceTechnicalName?: string;
  /** The MeasurementDevice of this tso is used for retrieval of the harmonic background levels */
  tsoId?: number;
  /** The MeasurementParameters for which the harmonic background levels will be
    exported */
  body: number[];
};
export type ApiCommonResponsesHarmonicBackgroundLevelParameterValuesResponse = {
  measurementParameterId?: number;
  data?: (number | null)[][] | null;
};
export const {
  usePostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesQuery,
  useLazyPostHarmonicBackgroundLevelGetHarmonicBackgroundLevelValuesQuery,
  usePostHarmonicBackgroundLevelExportHarmonicBackgroundLevelValuesMutation,
} = injectedRtkApi;
